<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="productVisible"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
	<template #company_id>
			  <a-select
			    v-decorator="['company_id',{rules: [
			      { required: true, message: '请选择企业' },
			    ]}]"
			    placeholder="请选择企业"
			  >
			    <a-select-option
			      v-for="item in companyData"
			      :key="item.id"
			      :value="item.id"
			    >
			      {{ item.companyInfo.qichacha_name }}
			    </a-select-option>
			  </a-select>
	</template>
	<template #product_id>
			  <a-select
			    v-decorator="[
			      'product_id',
			      { rules: [{ required: true, message: '请选择关联产品' }] },
			    ]"
			    placeholder="请选择关联产品"
			  >
			   <a-select-option
			     v-for="item in productData"
			     :key="item.id"
			     :value="item.id"
			   >
			     {{ item.title }}
			   </a-select-option>
			  </a-select>
	</template>
      <template #name>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入试卷名称',
                },
              ],
            },
          ]"
          placeholder="请输入试卷名称"
        />
      </template>
      <template #use_type>
        <a-select
          v-decorator="[
            'use_type',
            { rules: [{ required: true, message: '请选择试卷类型' }] },
          ]"
          placeholder="请选择试卷类型"
        >
          <a-select-option
            v-for="item in paperData"
            :key="item.key"
            :value="item.key"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>

      <template #aim>
        <a-textarea
          v-decorator="[
            'aim',
            { rules: [{ required: true, message: '请输入试卷说明' }] },
          ]"
          rows="6"
          placeholder="请输入试卷说明"
          maxlength="150"
        />
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>

<script>
	import {
		companyFormData,
		serviceFormData
	} from '../data/index';
export default {
  props: ['productVisible', 'title'],
  data() {
    return {
     formData: [],
	  productData:[],
      paperData: [{
        key: 1, name: '线上拜访',
      },
      {
        key: 2, name: '学术调研',
      },
      {
        key: 3, name: '科室会通知',
      }, {
        key: 4, name: '沙龙会',
      },
      { key: 5, name: '科室会邀请讲课' },
      ],

    };
  },
  mounted() {
	  if (this.$store.state.user.role === 1) {
	  	this.formData = serviceFormData;
	  } else {
	  	this.formData = companyFormData;
	  }
	  // 获取产品
	  this.getProduct();
	  this.getCompanyList()
  },
  methods: {
	  // 获取合作企业
	  async getCompanyList() {
	    let result = await this.$http.post('/Company/getCooperationCompanyList');
	    if (result.data.status === 1) {
	      this.companyData = result.data.data.data_list;
	    }
	  },
	  // 获取合作企业
	  async getProduct() {
	    let result = await this.$http.post('/product/getList');
	    if (result.data.status === 1) {
	      this.productData = result.data.data.data_list;
	    }
	  },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
